export default __webpack_public_path__ + "static/media/web_screenshot_1.2bf99b0f.png";